var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocDataMatch = function SvgDocDataMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 57,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13h50V6.75h-50V13ZM.25 6.75c0-1.72.612-3.19 1.836-4.415C3.31 1.111 4.78.5 6.5.5h50c1.719 0 3.19.611 4.414 1.835C62.138 3.56 62.75 5.031 62.75 6.75V25.5H6.5v18.75h12.813v6.25H6.5c-1.719 0-3.19-.612-4.414-1.836C.862 47.44.25 45.968.25 44.249V6.75Zm40.469 50L27.437 43.468l4.375-4.375 8.907 8.75 17.656-17.656 4.375 4.531L40.719 56.75ZM6.5 6.75v37.5-14.063 8.828V6.75Z"
  })));
};
export default SvgDocDataMatch;